<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm02_title"></a><a id="page_iii"></a><strong>Angels of Mercy</strong></h1>
<p class="subtitle"><strong>White Women and the History of New York’s Colored Orphan Asylum</strong></p>
<p class="author"><strong>William Seraile</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?643c373f